import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFeather2"><Path d="M3.5 16.2059V21C3.5 17.6311 6.28998 15.8429 9.33388 15.8429C13.1795 15.8429 16.0081 11.9857 13.9235 8.79412C17.346 8.79412 18.0928 6.23718 19.5 3.5H16.0081C9.10008 3.5 3.5 9.18862 3.5 16.2059Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFeather2;
